import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Details from "./app/admin/clients/DetailScreen";
import { AdminRoutes, AuthRoutes } from "./routes";
import { AuthLayout } from "./routes/Authlayout";
import { ProtectedLayout } from "./routes/ProtectedLayout";
import theme from "./theme";
import SnackbarAlert from "./components/snackbar";
import { snackConst } from "./constants/Variables";
import AdminOrderDetails from "./app/admin/order/OrderDetails";
import { useSelector } from "react-redux";
import AppointmentDetailPage from "./app/admin/appointments/AppointmentDetail";
import romaninanJson from "./utils/locales/ro/romanian.json";
import englishJson from "./utils/locales/en/english.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import AddEditBlog from "./app/admin/blogs/AddEditBlog";
import Snowfall from "react-snowfall";
import CompanyDetailPage from "./components/Specific/Company";
import { AttributeValue } from "./app/admin/catalogue/attribute";
import { PlanDetail } from "./app/admin/products/userPlan";
import ContentDetail from "./app/admin/contentHub/detail";

function App() {
  const USER_ROUTES = useSelector(
    (state) => state.userRoutesReducer.userRoutes
  );
  const currentLanguage = useSelector(
    (state) => state.languageReducer.currentLanguage
  );

  // i18n
  //   .use(initReactI18next) // passes i18n down to react-i18next
  //   .init({
  //     // the translations
  //     // (tip move them in a JSON file and import them,
  //     // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
  //     resources: {
  //       en: {
  //         translation: englishJson[0],
  //       },
  //       ro: {
  //         translation: romaninanJson[0],
  //       },
  //     },
  //     lng: currentLanguage, // if you're using a language detector, do not define the lng option
  //     fallbackLng: "en",

  //     interpolation: {
  //       escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  //     },
  //   });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route element={<AuthLayout />}>
            {AuthRoutes.map(({ component: Component, path, id }) => {
              return <Route key={id} path={path} element={Component} />;
            })}
          </Route>
          <Route path="/" element={<ProtectedLayout />}>
            {USER_ROUTES?.map(({ component: Component, path, id }) => (
              <Route key={id} path={path} element={Component} />
            ))}
            <Route path={"/details"} element={<Details />} />
            <Route path={"/blogs/:type/:id?"} element={<AddEditBlog />} />
            <Route path={"/sale/details/:id"} element={<AdminOrderDetails />} />
            <Route
              path={"/appointments/details/:id"}
              element={<AppointmentDetailPage />}
            />
            <Route path={"/company-details/:id"} element={<CompanyDetailPage />} />
            {/* <Route path={"/catalogue/attribute/:id"} element={<Attribute />} /> */}
            <Route path={"/catalogue/attribute-value/:attributeId"} element={<AttributeValue />} />
            <Route path={"/products/user-plan/:id"} element={<PlanDetail />} />
            <Route path={"/content-hub/:id"} element={<ContentDetail />} />
          </Route>
        </Routes>
        <SnackbarAlert
          ref={(ref) => {
            snackConst.snackRef = ref;
          }}
        />
      </ThemeProvider>
      {/* <Snowfall
        snowflakeCount={300}
        color="#7922D8"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      /> */}
    </LocalizationProvider>
  );
}

export default App;
